/* eslint-disable */
// @ts-nocheck
import { createSelector } from 'reselect';
import { DEFAULT_MAU_COUNT } from '../../screens/AccountSettings/ScreenBillingSettings/constants';
import { getBranchMauTier, isActiveSubscription } from '../../support/utils';
import { MAU_BILLING_TIER_IDS } from '../../support/constants';
import { INIT_STATE } from '../../reducers/SubscriptionsReducer';
import { getSubscriptionNumberOrNullFromSubscriptions } from './getSubscriptionNumberOrNullFromSubscriptions';
import { getSubscriptionHavingProductFromSubscriptions } from './getSubscriptionHavingProductFromSubscriptions';
import { PaymentBillToContact, MonthToDateMau, Subscription, SubscriptionReducer } from '../../types/subscriptionTypes';
import type { RootState } from 'client/js/redux';

export function getState(state: RootState): SubscriptionReducer {
  return (state && state.subscriptions) || INIT_STATE;
}

export const selectSubscriptions = createSelector<any, SubscriptionReducer, Subscription[]>(
  getState,
  (subscriptionState) => subscriptionState.data || []
);

export const selectSubscriptionNumberOrNull = createSelector<any, Subscription[], string | null>(
  selectSubscriptions,
  getSubscriptionNumberOrNullFromSubscriptions
);

export const selectSubscriptionHavingProduct: (state: RootState, productSKU: string) => string = createSelector(
  selectSubscriptions,
  (state: RootState, productSKU: string) => productSKU,
  getSubscriptionHavingProductFromSubscriptions
);

export const selectEffectiveStartDateOnProductInSubscriptions: (state: RootState, productSKU: string) => string =
  createSelector(selectSubscriptionHavingProduct, (subscriptionHavingProduct) => {
    if (!subscriptionHavingProduct) {
      return null;
    }
    return subscriptionHavingProduct.effective_start_date;
  });

export const selectIsProductOnActiveSubscription: (state: RootState, productSKU: string) => string = createSelector(
  selectSubscriptionHavingProduct,
  (subscriptionHavingProduct) => {
    if (!subscriptionHavingProduct) {
      return false;
    }
    return isActiveSubscription(subscriptionHavingProduct.status);
  }
);

export const selectIsOttActive: (state: RootState) => boolean = createSelector(selectSubscriptions, () => {
  // TODO: https://branch.atlassian.net/browse/ATTRUI-727
  //  Revert the logic to check the OTT product subscription status
  return true;
});

export const selectMauTier: (state: RootState) => string | null | undefined = createSelector(getState, (subscriptions) =>
  getBranchMauTier(subscriptions)
);

export const selectIsEnterprisePlan: (state: RootState) => boolean = createSelector(
  selectMauTier,
  (tier) => tier === MAU_BILLING_TIER_IDS.ENTERPRISE
);

export const selectMonthToDateMau: (state: RootState) => MonthToDateMau | null | undefined = createSelector(
  getState,
  (subscriptionState) => subscriptionState.monthToDateMau || null
);

export const selectLastMonthMau: (state: RootState) => number = createSelector(getState, (subscriptionState) => {
  if (subscriptionState.mau !== undefined && subscriptionState.mau !== null) {
    return subscriptionState.mau;
  }
  return DEFAULT_MAU_COUNT;
});

export const selectSubscriptionsAreLoading: (state: RootState) => boolean = createSelector(
  getState,
  (subscriptionState) => subscriptionState.loading
);

export const selectPaymentBillToContact: (state: RootState) => PaymentBillToContact | null | undefined = createSelector(
  getState,
  (subscriptionState) => subscriptionState.billToContact || null
);

export const selectAccountBalance = createSelector<any, SubscriptionReducer, string | null>(
  getState,
  (subscriptionState) => subscriptionState.balance
);

export const selectAccountBalanceLoading = createSelector<any, string | null, boolean>(
  selectAccountBalance,
  (balance) => balance === null
);
